import React from 'react';
import { Image } from 'react-konva';
import {
  isMobileTablet,
} from '../../library/calc';

const adjustTop = 22.5;
const adjustLeft = 24.6;
export class Lock extends React.Component {

  render() {
    let {
      left,
      top,
      node,
      cursorBecomesMove,
      cursorBecomesPointer,
      onclickedAddNodeTab,
      stopStageClickPropagation,
      userTouchedNode,
      hideMatchBubble,
    } = this.props;

    left += adjustLeft;
    top += adjustTop + 7.5;

    return (
        <Image
          image={this.props.lockTabImg}
          scaleX={.1}
          scaleY={.1}
          width={21*10}
          height={5.5*10}
          x={left}
          y={top}


          onTouchStart={()=>{
            userTouchedNode({
              node,
              callback: ()=>{
                if(isMobileTablet()) {
                  stopStageClickPropagation({fromWhere: 'addNodeComponent'});
                  onclickedAddNodeTab(node);
                  return;
                }
              },
              fromWhere: 'addnode component'});
          }}

          onMouseover={()=>{
            hideMatchBubble();
          }}

          onClick={(evt)=>{
            stopStageClickPropagation({fromWhere: 'addNodeComponent'});
            onclickedAddNodeTab(node);
          }}

          onMouseenter={()=>{
            cursorBecomesPointer();
          }}
          onMouseleave={()=>{
            cursorBecomesMove();
          }}



        />
    );
  }
}

